import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptorService implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = Number(req.headers.get('timeout')) || this.defaultTimeout;
    const MVC_DOMAIN_NAME = sessionStorage.getItem('mvcDomainName');
    const DOMAIN_URL = `https://${MVC_DOMAIN_NAME}`;
    if (req.url === `${DOMAIN_URL}/safe/upload-file.do`) {
      //console.log('called upload service');
      return next.handle(req).pipe(timeout(120000));
    }
    return next.handle(req).pipe(timeout(timeoutValue));
  }
}
